export const GET_SINGLE_USER = "GET_SINGLE_USER";

export const REGISTER_LOGIN_SIGNOUT_USER = "REGISTER_LOGIN_SIGNOUT_USER";

export const SAVE_USER_DATA = "SAVE_USER_DATA";

export const GET_USER_NAMES = "GET_USER_NAMES";

export const GET_POSTS = "GET_POSTS";

export const CREATE_POST = "CREATE_POST";

export const MAIN_LOADER = "MAIN_LOADER";

export const FIREBASE_LOADER = "FIREBASE_LOADER";

export const THEME_SWITCH = "THEME_SWITCH";

export const UPDATE_THEME = "UPDATE_THEME";

export const COMMENT_ON_POST = "COMMENT_ON_POST";

export const LIKE_POST = "LIKE_POST";

export const SAVE_POST = "SAVE_POST";

export const DELETE_POST = "DELETE_POST";

export const DELETE_POST_COMMENT = "DELETE_POST_COMMENT";
